(function(){
  "use strict";

  /* ================= PRICING CONFIG (cm-based, matches quote page) ================= */
  const PRICING_CONFIG = {
    materials: {
      standard:   { label: 'Standard Outdoor',  ratePerSqM: 360 },
      cast:       { label: 'Premium Cast',      ratePerSqM: 460 },
      reflective: { label: 'Reflective',        ratePerSqM: 560 },
      chrome:     { label: 'Chrome / Metallic', ratePerSqM: 680 }
    },
    buffer: 1.15,
    setupFee: 45,
    minimumOrderPrice: 120,
    maxHeightCm: 50
  };

  const ALLOWED = /\.(svg|ai|pdf)$/i;

  function shipCost(longestCm){
    if (longestCm <= 40) return 14;
    if (longestCm <= 80) return 22;
    if (longestCm <= 150) return 35;
    return 55;
  }

  function calculatePrice(s){
    const cfg = PRICING_CONFIG;
    const wCm = Math.max(1, parseFloat(s.width) || 0);
    const hCm = Math.min(cfg.maxHeightCm, Math.max(1, parseFloat(s.height) || 0));
    const material = cfg.materials[s.material] || cfg.materials.standard;
    const qty = Math.max(1, parseInt(s.quantity) || 1);
    const areaSqM = (wCm / 100) * (hCm / 100);
    const unitPrice = areaSqM * material.ratePerSqM * cfg.buffer;
    const ship = shipCost(Math.max(wCm, hCm));
    const fees = cfg.setupFee + ship;
    let total = unitPrice * qty + fees;
    total = Math.max(total, cfg.minimumOrderPrice);
    total = Math.ceil(total / 5) * 5;
    return { unitPrice, qty, fees, ship, setupFee: cfg.setupFee, total, materialLabel: material.label };
  }

  /* ================= STATE ================= */
  let currentMode = 'upload';
  let uploadedFile = null;

  /* ================= DOM HELPERS ================= */
  const $ = id => document.getElementById(id);
  const money = n => '$' + n.toFixed(2);

  function getCurrentSpec(){
    return {
      width: $('widthInput').value,
      height: $('heightInput').value,
      quantity: $('qtyInput').value,
      material: $('materialSelect').value
    };
  }

  function updatePrice(){
    const hEl = $('heightInput');
    if (parseFloat(hEl.value) > PRICING_CONFIG.maxHeightCm) hEl.value = PRICING_CONFIG.maxHeightCm;

    const result = calculatePrice(getCurrentSpec());
    $('pUnit').textContent = money(result.unitPrice);
    $('pQty').textContent = '×' + result.qty;
    $('pDiscount').textContent = '—';
    $('pSetup').textContent = money(result.fees);
    $('pTotal').textContent = money(result.total);
    $('proceedBtn').textContent = 'Request This Quote →';
    return result;
  }

  /* ================= TABS ================= */
  function setMode(mode){
    currentMode = mode;
    $('tabUpload').setAttribute('aria-selected', mode === 'upload');
    $('tabText').setAttribute('aria-selected', mode === 'text');
    $('panelUpload').hidden = mode !== 'upload';
    $('panelText').hidden = mode !== 'text';
    updatePrice();
  }
  $('tabUpload').addEventListener('click', () => setMode('upload'));
  $('tabText').addEventListener('click', () => setMode('text'));

  /* ================= UPLOAD FLOW (vector only) ================= */
  const dropzone = $('dropzone');
  const fileInput = $('fileInput');
  dropzone.addEventListener('click', () => fileInput.click());
  dropzone.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); } });
  dropzone.addEventListener('dragover', e => { e.preventDefault(); dropzone.classList.add('dragover'); });
  dropzone.addEventListener('dragleave', () => dropzone.classList.remove('dragover'));
  dropzone.addEventListener('drop', e => {
    e.preventDefault(); dropzone.classList.remove('dragover');
    if (e.dataTransfer.files.length) handleFile(e.dataTransfer.files[0]);
  });
  fileInput.addEventListener('change', e => { if (e.target.files.length) handleFile(e.target.files[0]); });
  $('changeFileBtn').addEventListener('click', () => fileInput.click());

  function handleFile(file){
    if (!ALLOWED.test(file.name)) {
      alert('Please upload a vector file only — SVG, AI or PDF.');
      fileInput.value = '';
      return;
    }
    uploadedFile = file;
    const wrap = document.querySelector('#artResult .art-preview-wrap');
    if (/\.svg$/i.test(file.name)) {
      const reader = new FileReader();
      reader.onload = e => { $('artPreview').src = e.target.result; if (wrap) wrap.style.display = ''; };
      reader.readAsDataURL(file);
    } else if (wrap) {
      wrap.style.display = 'none';
    }
    renderFileBadge(file.name);
    $('artResult').classList.add('show');
    if ($('lockAspectRow')) $('lockAspectRow').style.display = 'none';
    updatePrice();
  }

  function renderFileBadge(name){
    const wrap = $('artBadges');
    if (!wrap) return;
    wrap.innerHTML = '';
    const a = document.createElement('span');
    a.className = 'badge';
    a.textContent = '✓ ' + name;
    wrap.appendChild(a);
    const b = document.createElement('span');
    b.className = 'badge';
    b.textContent = 'Vector file';
    wrap.appendChild(b);
  }

  /* ================= TEXT FLOW ================= */
  function updateTextPreview(){
    const text = $('textInput').value.trim() || 'YOUR TEXT';
    const style = $('letterStyle').value;
    const preview = $('textPreview');
    preview.textContent = text;
    preview.style.fontFamily = style === 'medium' ? "var(--font-script)" : "var(--font-display)";
    preview.style.textTransform = style === 'medium' ? 'none' : 'uppercase';
  }
  $('textInput').addEventListener('input', updateTextPreview);
  $('letterStyle').addEventListener('change', () => { updateTextPreview(); updatePrice(); });
  $('textColorCount').addEventListener('change', updatePrice);
  updateTextPreview();

  /* ================= SIZE / QTY / MATERIAL ================= */
  $('widthInput').addEventListener('input', updatePrice);
  $('heightInput').addEventListener('input', updatePrice);
  $('materialSelect').addEventListener('change', updatePrice);
  $('qtyMinus').addEventListener('click', () => { $('qtyInput').value = Math.max(1, (parseInt($('qtyInput').value)||1) - 1); updatePrice(); });
  $('qtyPlus').addEventListener('click', () => { $('qtyInput').value = (parseInt($('qtyInput').value)||1) + 1; updatePrice(); });
  $('qtyInput').addEventListener('input', updatePrice);

  /* ================= PROCEED ================= */
  $('proceedBtn').addEventListener('click', () => {
    if (currentMode === 'upload' && !uploadedFile) {
      alert('Please upload your artwork (SVG, AI or PDF) before requesting a quote.');
      return;
    }
    const spec = getCurrentSpec();
    const result = calculatePrice(spec);
    const typeLabel = currentMode === 'upload' ? ('Uploaded file: ' + (uploadedFile ? uploadedFile.name : '')) : 'Text decal';
    const sizeLabel = spec.width + 'cm × ' + spec.height + 'cm';
    const materialLabel = PRICING_CONFIG.materials[spec.material].label;
    const priceLabel = money(result.total);

    $('recapType').textContent = typeLabel;
    $('recapSize').textContent = sizeLabel;
    $('recapMaterial').textContent = materialLabel;
    $('recapQty').textContent = spec.quantity;
    $('recapTotal').textContent = priceLabel;

    if ($('quoteFieldType')) $('quoteFieldType').value = typeLabel;
    if ($('quoteFieldSize')) $('quoteFieldSize').value = sizeLabel;
    if ($('quoteFieldMaterial')) $('quoteFieldMaterial').value = materialLabel;
    if ($('quoteFieldQty')) $('quoteFieldQty').value = spec.quantity;
    if ($('quoteFieldPrice')) $('quoteFieldPrice').value = priceLabel;
    if ($('quoteFieldSummary')) {
      $('quoteFieldSummary').value =
        'New quote request from the site calculator:\n' +
        '- Type: ' + typeLabel + '\n' +
        '- Size: ' + sizeLabel + '\n' +
        '- Vinyl: ' + materialLabel + '\n' +
        '- Quantity: ' + spec.quantity + '\n' +
        '- Estimated price: ' + priceLabel;
    }
    $('payBtn').textContent = 'Request This Quote — ' + money(result.total);

    const orderSection = $('orderSection');
    orderSection.hidden = false;
    orderSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ================= INIT ================= */
  fileInput.setAttribute('accept', '.svg,.ai,.pdf');
  const _dzStrong = document.querySelector('#dropzone strong');
  if (_dzStrong) _dzStrong.textContent = 'Drop your vector file here, or click to browse';
  const _dzSpan = document.querySelector('#dropzone span');
  if (_dzSpan) _dzSpan.textContent = 'SVG, AI or PDF — vector only';

  const _wLabel = document.querySelector('label[for="widthInput"]');
  if (_wLabel) _wLabel.textContent = 'Width (cm)';
  const _hLabel = document.querySelector('label[for="heightInput"]');
  if (_hLabel) _hLabel.textContent = 'Height (cm)';
  if ($('widthInput'))  $('widthInput').value = 30;
  if ($('heightInput')) $('heightInput').value = 20;

  const _setupLabel = $('pSetup') && $('pSetup').previousElementSibling;
  if (_setupLabel) _setupLabel.textContent = 'Setup, weeding & shipping';
  const _discountRow = $('pDiscount') && $('pDiscount').closest('.ticket-row');
  if (_discountRow) _discountRow.style.display = 'none';

  updatePrice();
})();